import { ORDER_PAYMENT_DEDUCTION_TYPES, OrderPaymentType, OrderStatus, TONU_ORDER_STATUSES } from "@/constants/order";
import { generateId } from "@/utils/generateId";
import type { OrderPayment } from "@/api/orders/dto/order.dto";

export function useOrderPayments() {
  function createOrderPaymentDraft(type: string | null = null, rate: number | null = null): OrderPayment {
    return { tempId: generateId(), type, rate };
  }

  function isDeductionPaymentType(type: string | null) {
    return ORDER_PAYMENT_DEDUCTION_TYPES.some((deductionType) => deductionType === type);
  }

  function getMandatoryOrderPaymentType(status?: OrderStatus): OrderPaymentType {
    if (status && TONU_ORDER_STATUSES.includes(status)) {
      return OrderPaymentType.Tonu;
    }

    return OrderPaymentType.FlatLinehaul;
  }

  function createMandatoryOrderPayment(payments: OrderPayment[], status?: OrderStatus): OrderPayment[] {
    const mandatoryType = getMandatoryOrderPaymentType(status);

    if (payments.some((payment) => payment.type === mandatoryType)) {
      return payments;
    }

    const rate = status === OrderStatus.waitingTonu ? 0 : null;

    return [...payments, createOrderPaymentDraft(mandatoryType, rate)];
  }

  return {
    createOrderPaymentDraft,
    isDeductionPaymentType,
    getMandatoryOrderPaymentType,
    createMandatoryOrderPayment,
  };
}
